export default {
  setNewlyCreatedInvoice(state, value){
    state.newlyCreatedInvoice = value
},
};
